import React, { type FC } from 'react';
import { Star } from 'lucide-react';
import { CardShell } from './card-shell';
import { ApprovalBanner } from './approval-banner';
import type { ToolCardProps } from './types';
import { safeGet } from './types';

export const CandidateActionCard: FC<ToolCardProps> = ({
  toolName,
  args,
  result,
  stage,
  approvalId,
}) => {
  const action = (args.action as string) ?? 'add';
  const isAdd = action !== 'remove';
  const candidateName =
    safeGet<string>(result, 'name') ??
    safeGet<string>(args, 'candidateName') ??
    'Candidate';
  const jobRef =
    safeGet<string>(args, 'jobTitle') ??
    safeGet<string>(args, 'jobId');

  if (stage === 'pending_approval') {
    return (
      <CardShell>
        <div style={{ padding: 18, display: 'flex', flexDirection: 'column', gap: 8 }}>
          <div
            style={{
              fontSize: 14,
              fontWeight: 600,
              color: 'var(--text-primary)',
            }}
          >
            {isAdd ? 'Add to shortlist?' : 'Remove from shortlist?'}
          </div>
          <div
            style={{
              fontSize: 13,
              color: 'var(--text-secondary)',
            }}
          >
            {candidateName}
            {jobRef && (
              <span style={{ color: 'var(--text-tertiary)' }}>
                {' '}for {jobRef}
              </span>
            )}
          </div>
        </div>
        {approvalId && (
          <ApprovalBanner
            approvalId={approvalId}
            toolName={toolName}
            description="Confirm shortlist action?"
          />
        )}
      </CardShell>
    );
  }

  // completed / other stages
  return (
    <CardShell>
      <div
        style={{
          padding: 18,
          display: 'flex',
          flexDirection: 'column',
          gap: 4,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <Star
            size={16}
            fill={isAdd ? 'var(--text-secondary)' : 'none'}
            stroke={isAdd ? 'var(--text-secondary)' : 'var(--text-tertiary)'}
            style={{ flexShrink: 0 }}
          />
          <span
            style={{
              fontSize: 14,
              fontWeight: 600,
              color: 'var(--text-primary)',
            }}
          >
            {isAdd
              ? `Added ${candidateName} to shortlist`
              : `Removed ${candidateName} from shortlist`}
          </span>
        </div>
        {jobRef && (
          <div
            style={{
              fontSize: 12,
              color: 'var(--text-tertiary)',
              paddingLeft: 24,
            }}
          >
            for {jobRef}
          </div>
        )}
      </div>
    </CardShell>
  );
};
